import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withCtx as _withCtx, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "flex flex-col max-w-[768px] mx-auto shadow-base rounded-b-3xl" }
const _hoisted_2 = { class: "p-3" }
const _hoisted_3 = { class: "bg-light-gray-100 rounded-b-3xl p-5 flex flex-col gap-3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "flex h-full w-full items-center justify-center"
}
const _hoisted_6 = { class: "absolute flex justify-end w-[265px] -mt-[69px]" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "w-14 h-14 bg-[#FF7E00] rounded-xl overflow-hidden"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "text-xl font-black dark:text-primary-black" }
const _hoisted_11 = { class: "text-xl font-medium dark:text-primary-black" }
const _hoisted_12 = { class: "flex text-lg dark:text-primary-black" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "flex justify-between px-10 my-5"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold flex flex-col items-center" }, [
  /*#__PURE__*/_createTextVNode("50 "),
  /*#__PURE__*/_createElementVNode("p", { class: "font-normal opacity-70" }, "Posts")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold flex flex-col items-center" }, [
  /*#__PURE__*/_createTextVNode("520 "),
  /*#__PURE__*/_createElementVNode("p", { class: "font-normal opacity-70" }, "Connections")
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold flex flex-col items-center" }, [
  /*#__PURE__*/_createTextVNode("130,000 "),
  /*#__PURE__*/_createElementVNode("p", { class: "font-normal opacity-70" }, "Followers")
], -1)
const _hoisted_19 = [
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = { class: "flex items-center justify-between mx-5 border-t-1 border-light-gray-300" }
const _hoisted_21 = { class: "flex gap-5 py-5" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "bg-white dark:bg-primary-black shadow-base rounded-xl-100 flex flex-col py-3 gap-3 rounded-base w-[13rem] -ml-40" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "hover:bg-primary-violet/20 py-1 pl-3",
    href: "/talent-profile/edit"
  }, "Edit profile"),
  /*#__PURE__*/_createElementVNode("span", {
    id: "open-modal",
    class: "hover:bg-primary-violet/20 py-1 pl-3"
  }, "Share profile")
], -1)
const _hoisted_24 = { class: "flex flex-row gap-3 p-5" }
const _hoisted_25 = ["src"]
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "workbean workbean-copy" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

import { ref, computed, onBeforeMount, watch, onMounted } from "vue"
  import { IonIcon, IonContent, IonCard, IonPage, IonModal, IonFab, IonFabButton, IonFabList } from "@ionic/vue"
  import { ellipsisHorizontal, download, helpOutline } from "ionicons/icons"
  import { toastController } from "@ionic/core"
  import { useRoute, useRouter } from "vue-router"
  import { useCompanyStore } from "@/store/company"
  import { useNewsFeedStore } from "@/store/newsfeed"
  import { useResourcesStore } from "@/store/resources"
  import { useUserStore } from "@/store/user"
  import { useMetadataStore } from "@/store/metadata"
  import { includes, filter } from "lodash"

  import PostsContainer from "@/components/talent-profile/PostsContainer.vue"
  import AboutContainer from "@/components/talent-profile/AboutContainer.vue"
  import WorksonaContainer from "@/components/talent-profile/worksona/WorksonaContainer.vue"
  import fbIcon from "@/assets/images/social-media/facebook-icon.svg"
  import linkedinIcon from "@/assets/images/social-media/linkedin-icon.svg"
  import Menubar from "@/components/menuBar.vue"

  import CompanyImage from "@/assets/images/discover/atlassian-image.svg"
  import UserImage from "@/assets/images/discover/people-image.png"
  import WorksonaImage from "@/assets/images/discover/worksona.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TalentProfile',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const userStore = useUserStore()
  const resourcesStore = useResourcesStore()
  const companyStore = useCompanyStore()
  const newsfeedStore = useNewsFeedStore()
  const metadata = useMetadataStore()
  const activeTab = computed({
    get: () => (route.params.tab as string) || "posts",
    set: (val: string) => redirect(val),
  })

  const meta = computed(() => ({
    title: resourcesStore.worksona.name,
    type: "website",
    description: resourcesStore.worksona.description,
    image: resourcesStore.worksona.image_with_icon,
    url: window.location.href,
    site: window.location.href,
  }))
  const userProfile = computed(() => userStore.userTalentProfile)
  const hasProfilePhoto = computed(() => userProfile.value.photo.length)
  const companyLogo = ref("")
  const companyName = computed(() => (isVisible("company") ? userProfile.value.employment.company || "" : ""))
  const companyCity = computed(() => (isVisible("company_location") ? userProfile.value.employment.company_location.city || "" : ""))
  const companyCountry = computed(() => (isVisible("company_location") ? userProfile.value.employment.company_location.country || "" : ""))
  const hasDownloadButton = computed(() => (userProfile.value.uploaded_cv.length ? true : false))
  const hasEditButton = computed(() => userProfile.value.user_id === userStore.customerDetails.profile.user_id)
  const userBio = computed(() => userProfile.value.bio.replaceAll("&nbsp;", " "))

  const options = ["posts", "about", "worksona"]

  /**
   * is data visible
   * @param column
   */
  const isVisible = (column: string) => {
    return includes(userStore.userTalentProfile.visibility, column)
  }

  /**
   * copy URL
   */
  const copyUrl = async () => {
    navigator.clipboard.writeText(window.location.href)

    const toast = await toastController.create({
      message: "Worksona result copied to clipboard",
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }
  // Redirects to the specific tab inside company page
  const redirect = (tab: string) => {
    if (tab === "posts") {
      router.push(`/talent-profile/${route.params.user}/${route.params.slug}`)
    } else if (route.params.tab != null && tab !== route.params.tab) {
      router.push(`/talent-profile/${route.params.user}/${route.params.slug}/${tab}`)
    }
  }

  const redirectWorksona = () => {
    if (userStore.worksona.length > 0) router.push(`/talent-profile/${route.params.user}/${route.params.slug}/worksona`)
    else router.push("/survey/worksona")
  }
  /**
   * download cv
   */
  const downloadCV = () => {
    window.open(userProfile.value.uploaded_cv, "_blank")
  }

  /**
   * initialize talent profile data
   */
  const initialize = async () => {
    // loading.fullpage = true
    const routeTab = router.currentRoute.value.params.tab as any
    const routeSlug = router.currentRoute.value.params.slug as any
    const success = await userStore.retrieveTalentProfile(`${router.currentRoute.value.params.user}`)
    if (success) {
      if (companyName.value.length) {
        await companyStore.retrieveAllCompanies(
          {
            keyword: companyName.value,
            columns: "name,logo",
            page: 1,
            limit: 5,
          },
          "search"
        )
        companyLogo.value = companyStore.searchResult.length ? filter(companyStore.searchResult, (val) => val.name === companyName.value)[0]?.logo || "" : ""
      }
      const userSlug = `${userProfile.value.name.first_name.trim().toLowerCase()} ${userProfile.value.name.last_name.trim().toLowerCase()}`.replace(/\s+/g, "-")
      if (routeSlug == null || routeSlug == "") router.replace(`/talent-profile/${router.currentRoute.value.params.user}/${userSlug}`)
      else if (`${routeSlug}` !== `${userSlug}` || (routeTab != null && routeTab != "" && routeTab != "about" && routeTab != "worksona")) router.replace("/not-found")
    } else if (hasEditButton.value) router.replace("/details")
    else router.replace("/not-found")
    // loading.fullpage = false
  }

  /**
   * initialize worksona
   */
  const initWorksona = async () => {
    // loading.fullpage = true
    if (userStore.worksona.length > 0) {
      await resourcesStore.retrieveWorksonaResult(userStore.worksona)
      // loading.fullpage = false
    } else {
      userStore.getWorksonaResult("public")
      // loading.fullpage = false
    }
  }

  onBeforeMount(initialize)
  onMounted(async () => {
    // loading.fullpage = true
  })
  watch(
    [() => userStore.userTalentProfile.worksona, () => userStore.worksona],
    () => {
      initWorksona()
    },
    { deep: true }
  )
  watch(
    () => router.currentRoute.value.params.user,
    (value) => {
      if (value) initialize()
    }
  )

return (_ctx: any,_cache: any) => {
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(Menubar)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(["h-[410px] w-[280px] bg-[#F2F4F9] rounded-3xl overflow-hidden relative", { 'shadow-xl': _unref(hasProfilePhoto), 'border-dashed border-1 border-light-gray-200': !_unref(hasProfilePhoto) }])
              }, [
                (_unref(hasProfilePhoto))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "h-full w-full object-cover",
                      src: _unref(userProfile).photo,
                      alt: _unref(userProfile).name.first_name
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_unref(IonIcon), { icon: _unref(helpOutline) }, null, 8, ["icon"])
                    ])),
                _createElementVNode("div", _hoisted_6, [
                  (_unref(hasEditButton))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "w-14 h-14 bg-[#FF7E00] rounded-xl overflow-hidden",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (redirectWorksona()))
                      }, [
                        (_unref(userStore).worksona.length)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "h-full w-full object-cover",
                              src: _unref(resourcesStore).worksona.icon,
                              alt: _unref(resourcesStore).worksona.archetype
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createBlock(_unref(IonIcon), {
                              key: 1,
                              icon: _unref(helpOutline),
                              class: "p-5"
                            }, null, 8, ["icon"]))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_unref(userStore).worksona.length)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (redirectWorksona()))
                            }, [
                              _createElementVNode("img", {
                                class: "h-full w-full object-cover",
                                src: _unref(resourcesStore).worksona.icon,
                                alt: _unref(resourcesStore).worksona.archetype
                              }, null, 8, _hoisted_9)
                            ]))
                          : (_openBlock(), _createBlock(_unref(IonIcon), {
                              key: 1,
                              icon: _unref(helpOutline),
                              class: "p-5"
                            }, null, 8, ["icon"]))
                      ]))
                ])
              ], 2),
              _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(userProfile).name.full_name ? _unref(userProfile).name.full_name : `${_unref(userProfile).name.first_name} ${_unref(userProfile).name.last_name}`), 1),
              _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref(userProfile).employment.role), 1),
              _createElementVNode("p", _hoisted_12, [
                (companyLogo.value.length)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: companyLogo.value,
                      alt: "",
                      class: "w-6 h-6 object-cover object-center rounded-full p-auto m-auto mr-2"
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_unref(companyName)) + " " + _toDisplayString(_unref(companyName).length && (_unref(companyCity).length || _unref(companyCountry).length) ? "•" : "") + " " + _toDisplayString(_unref(companyCity).length ? `${_unref(companyCity)}, ` : "") + " " + _toDisplayString(_unref(companyCountry)), 1)
              ]),
              _createElementVNode("p", {
                class: "dark:text-primary-black",
                innerHTML: _unref(userProfile).bio
              }, null, 8, _hoisted_14)
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_19))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("ul", _hoisted_21, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
                  return _createElementVNode("li", {
                    key: `${option}_id`,
                    class: "capitalize cursor-pointer",
                    style: _normalizeStyle(
                _unref(activeTab) === `${option}`
                  ? {
                      'border-bottom-width': '4px',
                      'margin-bottom': '-1.25rem',
                      'font-weight': 700,
                      color: '#7442C8',
                    }
                  : ''
              ),
                    onClick: ($event: any) => (activeTab.value = option)
                  }, _toDisplayString(option), 13, _hoisted_22)
                }), 64))
              ]),
              (_unref(activeTab) === 'about' && _unref(hasEditButton))
                ? (_openBlock(), _createBlock(_unref(IonFab), {
                    key: 0,
                    horizontal: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonFabButton), {
                        color: "medium",
                        class: "px-2 py-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(ellipsisHorizontal) }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonFabList), { side: "bottom" }, {
                        default: _withCtx(() => [
                          _hoisted_23
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_unref(IonModal), {
                ref: "modal",
                trigger: "open-modal",
                "initial-breakpoint": 0.2,
                breakpoints: [0, 0.2, 0.5, 0.3]
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonContent), null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(_component_ShareNetwork, {
                          network: "facebook",
                          url: _unref(meta).url,
                          media: _unref(meta).image,
                          title: _unref(meta).title,
                          description: _unref(meta).description,
                          hashtags: `workbean,worksona,${_unref(resourcesStore).worksona.codename}`,
                          class: "bg-primary-black w-[45px] h-[45px] rounded-[8px]"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _unref(fbIcon),
                              alt: "Share to facebook",
                              class: "w-full h-full object-fit p-[10px]"
                            }, null, 8, _hoisted_25)
                          ]),
                          _: 1
                        }, 8, ["url", "media", "title", "description", "hashtags"]),
                        _createVNode(_component_ShareNetwork, {
                          network: "linkedin",
                          url: _unref(meta).url,
                          media: _unref(meta).image,
                          title: _unref(meta).title,
                          description: _unref(meta).description,
                          hashtags: `workbean,worksona,${_unref(resourcesStore).worksona.codename}`,
                          class: "bg-primary-black w-[45px] h-[45px] rounded-[8px]"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _unref(linkedinIcon),
                              alt: "Share to LinkedIn",
                              class: "w-full h-full object-fit p-[10px]"
                            }, null, 8, _hoisted_26)
                          ]),
                          _: 1
                        }, 8, ["url", "media", "title", "description", "hashtags"]),
                        _createElementVNode("button", {
                          class: "bg-primary-black text-white w-[45px] h-[45px] rounded-[8px] p-[2px]",
                          onClick: copyUrl
                        }, _hoisted_28)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["initial-breakpoint", "breakpoints"]),
              (_unref(activeTab) === 'worksona')
                ? (_openBlock(), _createBlock(_component_ion_button, {
                    key: 1,
                    onClick: downloadCV
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        class: "-mt-1 mr-2",
                        icon: _unref(download)
                      }, null, 8, ["icon"]),
                      _createTextVNode("CV")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_unref(IonCard), { class: "ion-no-padding max-w-[768px] mx-auto" }, {
            default: _withCtx(() => [
              (_unref(activeTab) === 'posts')
                ? (_openBlock(), _createBlock(PostsContainer, { key: 0 }))
                : _createCommentVNode("", true),
              (_unref(activeTab) === 'about')
                ? (_openBlock(), _createBlock(AboutContainer, { key: 1 }))
                : _createCommentVNode("", true),
              (_unref(activeTab) === 'worksona')
                ? (_openBlock(), _createBlock(WorksonaContainer, { key: 2 }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})